export default defineNuxtPlugin({
  name: 'consentmanager',
  setup() {
    const runtimeConfig = useRuntimeConfig()
    const cmp = runtimeConfig.public.cmp
    const route = useRoute()

    if (
      !cmp?.enabled ||
      !cmp?.cdid ||
      Boolean(getQueryParam(route?.query, 'storeMode'))
    ) {
      return
    }

    useHead(() => ({
      link: [
        {
          key: 'cmp-preconnect',
          rel: 'preconnect',
          crossorigin: '',
          href: 'https://cdn.consentmanager.net',
        },
      ],
      script: [
        {
          src: 'https://cdn.consentmanager.net/delivery/js/semiautomatic.min.js',
          type: 'text/javascript',
          key: 'cmp-script',
          body: true,
          'data-cmp-ab': cmp?.ab ?? 1,
          'data-cmp-cdid': cmp?.cdid,
          'data-cmp-host': cmp?.host ?? 'c.delivery.consentmanager.net',
          'data-cmp-cdn': cmp?.cdn ?? 'cdn.consentmanager.net',
          'data-cmp-codesrc': cmp?.codesrc ?? 0,
        },
      ],
    }))
  },
})
